/* ═══════════════════════════════════════════════════
   AURESSEN+ Perks Snippet — Script
   File: auressen-plus-snippet.js

   Auto-injects below <product-price> on Origin theme.
   Only shows on products tagged "essential oil".
═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  var LEARN_MORE_URL = '/pages/auressen';

  if (window.location.pathname.indexOf('/products/') === -1) return;

  function buildSnippet() {
    return '' +
      '<div class="aup-snippet" id="aup-snippet">' +
        '<div class="aup-trigger">' +
          '<span class="aup-line"></span>' +
          '<span class="aup-price-text">' +
            'Up to <span class="aup-hl">$46.90</span> with <strong>AURESSEN+</strong>' +
          '</span>' +
          '<span class="aup-save">Save up to $20.10</span>' +
        '</div>' +
        '<button class="aup-toggle" id="aup-toggle" type="button" aria-expanded="false" aria-controls="aup-expand">' +
          '<span class="aup-toggle-show">See AURESSEN+ perks</span>' +
          '<span class="aup-toggle-hide">Hide perks</span>' +
          '<span class="aup-chevron" aria-hidden="true">&#9662;</span>' +
        '</button>' +
        '<div class="aup-expand" id="aup-expand" role="region" aria-labelledby="aup-toggle">' +
          '<div class="aup-perks">' +
            '<div class="aup-perk"><span class="aup-perk-icon" aria-hidden="true">&#10022;</span> 20\u201330% off all oils</div>' +
            '<div class="aup-perk"><span class="aup-perk-icon" aria-hidden="true">&#10022;</span> Extended warranty on all machines as long as active</div>' +
            '<div class="aup-perk"><span class="aup-perk-icon" aria-hidden="true">&#10022;</span> Concierge support</div>' +
            '<div class="aup-perk"><span class="aup-perk-icon" aria-hidden="true">&#10022;</span> More AURESSEN+ exclusives</div>' +
          '</div>' +
          '<a href="' + LEARN_MORE_URL + '" class="aup-learn">' +
            'Learn more about AURESSEN+ ' +
            '<span class="aup-learn-arrow" aria-hidden="true">&rarr;</span>' +
          '</a>' +
        '</div>' +
      '</div>';
  }

  function placeSnippet() {
    if (document.getElementById('aup-snippet')) return;

    /*
     * Origin theme structure (from DevTools):
     *
     *   <div>
     *     <div ref="priceContainer">
     *       <span class="price">$67.00</span>
     *     </div>
     *   </div>                    ← this is inside <product-price>
     * </product-price>
     *
     * We target <product-price> and insert after it.
     */

    var target = document.querySelector('#MainContent product-price');

    if (!target) {
      target = document.querySelector('product-price');
    }

    if (!target) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildSnippet();
    var snippet = wrapper.firstChild;

    target.parentNode.insertBefore(snippet, target.nextSibling);

    var toggle = document.getElementById('aup-toggle');
    if (toggle && snippet) {
      toggle.addEventListener('click', function () {
        snippet.classList.toggle('aup-open');
        var isNowOpen = snippet.classList.contains('aup-open');
        toggle.setAttribute('aria-expanded', isNowOpen ? 'true' : 'false');
      });
    }
  }

  function init() {
    var path = window.location.pathname.split('?')[0];
    if (path.charAt(path.length - 1) === '/') path = path.slice(0, -1);

    fetch(path + '.js')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.tags) return;

        var tags = Array.isArray(data.tags)
          ? data.tags
          : data.tags.split(',').map(function (t) { return t.trim(); });

        var hasTag = tags.some(function (t) {
          return t.toLowerCase() === 'essential oil';
        });

        if (hasTag) placeSnippet();
      })
      .catch(function () { /* silent */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
